import React, { useState } from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Paper, Typography } from '@mui/material';
import { makeStyles, withStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import Info from '.';
import { warehousePrinterState } from 'atoms/WarehousePrinterState';
import { addWarehousePrinter, deleteWarehousePrinter } from 'repositories/HttpRepository';

const headCells = [
  { id: 'uid', label: 'UID', align: 'center', isDisableSort: true },
  { id: 'name', label: 'Printer Name', isDisableSort: true },
  { id: 'mac', label: 'Mac Address', align: 'center', isDisableSort: true },
  { id: 'ip', label: 'IP Address', align: 'center', isDisableSort: true },
  { id: 'action', label: '', align: 'center', isDisableSort: true },
];

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    padding: 20,
  },
  Paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    overflowY: 'auto',
    boxShadow: 'none',

    '& form': {
      width: '100%',
    },
  },

  CloseBtn: {
    padding: theme.spacing(1),
  },
  CancelBtn: {
    border: 'solid 1px #4a4a4a',
    backgroundColor: '#ffffff',
    padding: '3px 15px',
  },
  SaveBtn: {
    backgroundColor: '#4abc4e !important',
    padding: '4px 25px',
    color: '#fff',
  },
  DialogTitle: {
    backgroundColor: '#fff',
  },
  DialogAction: {
    padding: 0,
    margin: theme.spacing(4, 0),
    backgroundColor: '#fff',
  },
  DialogContent: {
    backgroundColor: '#fff',
  },
  closeBtn: {
    position: 'absolute',
    right: 20,
    top: 20,
    color: '#d8d8d8',
    fontSize: 30,
    cursor: 'pointer',
  },
}));

function PrinterInfo(props) {
  const { datas, warehouse_id } = props;
  const { classes } = useStyles();
  const [turnOnAddDevice, setTurnOnAddDevice] = useState(false);

  const newPrinter = {
    name: '',
    uid: '',
    mac: '',
    ip: '',
  };

  const [existedPrinters, setExistedPrinters] = useRecoilState(warehousePrinterState);

  const navigate = useNavigate();

  const StyledTextField = withStyles(TextField, (theme) => ({
    root: {
      marginTop: theme.spacing(2),
    },
  }));

  function handleDisplayScreen(e) {
    setTurnOnAddDevice(true);
  }

  function processData(datas) {
    let result = [];
    datas.forEach((data) => {
      result.push({
        uid: data.uid,
        name: data.name,
        mac: data.mac,
        ip: data.ip,
        id: data._id,
      });
    });

    return result;
  }

  function handleSave(e) {
    if (!newPrinter.name || !newPrinter.uid || !newPrinter.mac) {
      toast.error('Please fill all require fields!');
      return;
    }
    addWarehousePrinter(warehouse_id, newPrinter).then((res) => {
      if (res.ok) {
        toast.success('added printer !');
        // console.log(newPrinter);
        setExistedPrinters([...existedPrinters, newPrinter]);
        setTurnOnAddDevice(false);
      } else {
        toast.error(res.data.message);
      }
    });
  }

  // no-dd-sa:javascript-code-style/parameter-name
  function handleRemoveDevice(printer_id) {
    deleteWarehousePrinter(printer_id).then((res) => {
      if (res.ok) {
        toast.success('remove successfully !');
        let tmp = existedPrinters.filter((obj) => {
          return obj._id !== printer_id;
        });
        setExistedPrinters(tmp);
      } else {
        toast.error('Server is having problem, please try again later.');
      }
    });
  }

  function handleOnChange(e) {
    // e.preventDefault();

    const { name, value } = e.target;
    newPrinter[name] = value;
  }

  function turnOffAddPrinter() {
    setTurnOnAddDevice(false);
  }

  return (
    <div>
      <Info
        key="printerInfo"
        title="Printers Info:"
        labelAddBtn="Add device"
        displayAddScreen={handleDisplayScreen}
        headings={headCells}
        remove={handleRemoveDevice}
        removeLabelApprove="YES, remove printer"
        datas={processData(existedPrinters)}
        isPrinter={true}
      ></Info>
      {turnOnAddDevice && (
        <Dialog
          open={true}
          onClose={() => {
            /* empty */
          }}
          aria-labelledby="form-dialog-title"
          maxWidth="md"
          className={classes.DialogRoot}
          fullWidth
        >
          <DialogTitle id="form-dialog-title" className={classes.DialogTitle}>
            <Typography variant="h4">Add Printer</Typography>
            <CloseIcon className={classes.closeBtn} onClick={turnOffAddPrinter} />
          </DialogTitle>
          <DialogContent className={classes.DialogContent}>
            <div className={classes.AddPrinter}>
              <Paper className={classes.Paper}>
                <form noValidate autoComplete="off" onChange={handleOnChange}>
                  <StyledTextField
                    type="text"
                    id="name"
                    name="name"
                    label="Printer Name"
                    required
                    fullWidth
                    variant="outlined"
                  />
                  <StyledTextField type="text" id="uid" name="uid" label="UID" required fullWidth variant="outlined" />
                  <StyledTextField
                    type="text"
                    id="mac"
                    name="mac"
                    label="MAC Address"
                    required
                    fullWidth
                    variant="outlined"
                  />
                  <StyledTextField type="text" id="ip" name="ip" label="IP Address" fullWidth variant="outlined" />
                </form>
              </Paper>
            </div>

            <DialogActions className={classes.DialogAction}>
              <Button className={classes.CancelBtn} onClick={turnOffAddPrinter} color="inherit">
                CANCEL
              </Button>
              <Button className={classes.SaveBtn} onClick={handleSave}>
                SAVE
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}

export default React.memo(PrinterInfo);
